import { Link, useNavigate } from 'react-router-dom';
import ls from './login-sign.module.css';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { togglelog, togglesign } from '../../store/logslic';
import { login, get_notifications } from '../../api/internal';
import { setUser } from '../../store/userslice';
import { useFormik } from 'formik';
import { logschema } from '../../schema/signschema';
import TextInput from '../textinput/textinput';
import { setUserNotif, setSeen } from '../../store/notiSlice';
import { GetChats } from '../../api/internal';
import { setChats } from '../../store/chatSlice';
import { Eye, Loader, Loader2 } from 'lucide-react';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toggleSignComp = () => { dispatch(togglesign()) };
    const [load, setLoad] = useState(false);
    const [passerror, setpasserror] = useState('');
    const [usererror, setusererror] = useState('');
    const [show, setShow] = useState(false);

    const { values, handleChange, touched, handleBlur } = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: logschema
    })

    console.log(values)
    async function handleclick(e) {
        setLoad(true);
        setpasserror('');
        setusererror('');
        e.preventDefault();
        try{
            const log = {
                username: values.username,
                password: values.password
            }
    
            const responce = await login(log);
            if (responce.status === 200) {
                setLoad(false);
                console.log(responce.data);
                const user = {
                    username: responce.data.username,
                    _id: responce.data._id,
                    photo: responce.data.photo,
                    auth: responce.data.auth,
                    name: responce.data.name
                }
                console.log(responce.data);
                dispatch(setUser(user));
    
                navigate('/home');
                let notifs = await get_notifications(user.username);
                let chats = await GetChats(user._id);
                let chat = chats.data.chat;
                dispatch(setChats(chat));
                if (notifs.status === 200) {
                    console.log(notifs.data.notis);
                    const notification = notifs.data.notis.notification;
                    dispatch(setUserNotif(notification));
    
                    
                    if(notification && notification.length > 0) {
                            for (let i = 0; i < 4; i++) {
                                if (notification[i].is_seen !== undefined && notification[i].is_seen === false) {
                                    dispatch(setSeen(false));
                                    console.log(i);
                                }
                            }
                    }
                    
    
                } else {
                    console.log(notifs.data);
                    setLoad(false)
                }
            } else if (responce.status === 500) {
                setLoad(false)
             
            }

        }catch(error){
            setLoad(false);
            console.log(error);
            if(error.response) {
              const { data } = error.response;
              if(data && data.message) {
                console.log(data);
                if(data.message === "Wrong Password"){
                  setpasserror("Wrong Password");
                }
                if(data.message === "Username not Found"){
                  setusererror("Username not Found")
                }
              }
            } else {
              // Handle any other unexpected errors
              console.log('Unexpected error occurred:', error);
              alert('Unexpected error occurred');
            }
          }
    }

    return (
        <div className={ls.log}>

            <div className={ls.login}>

                <h2>Welcome to Kintify</h2>
                <form className={ls.logform}>

                    <h>Username</h>
                    <TextInput
                        type='text'
                        onChange={handleChange}
                        name='username'
                        value={values.username}
                        placeholder='username'
                        required
                    />
                    {usererror && <p style={{color:'red',fontSize:'9px',marginTop:-7,marginLeft:20}}>username doesn't exist </p>}
                    <h>Password</h>
                    <span className={ls.pas}>
                        <TextInput
                            type={show ? 'text' : `password`}
                            onChange={handleChange}
                            name='password'
                            value={values.password}
                            placeholder='password'
                            required
                        />
                        <div onClick={() => setShow(!show)}><Eye color={show ? 'red' : 'black'} width={'20px'} style={{ marginTop: '6px', marginLeft: '3px' }} className={ls.show} /></div>
                    </span>
                        {passerror && <p style={{color:'red',fontSize:'9px',marginTop:-7,marginLeft:20}}>wrong password</p>}

                </form>
                

                <div className={ls.logbutton}><button onClick={handleclick} type='submit'>
                    login
                    </button></div>

                <div className={ls.signbutton}>
                    sign up instead ? <button onClick={toggleSignComp}>signup</button>
                </div>
            </div>
        </div>
    );
}


export default Login;